import { Box, Flex, Image } from "@chakra-ui/react";
import React from "react";
import Multistep from "../CanvasPages/MultiStepForm";
import invitationBG from "../../assets/InvitationBg.png";

const CreateInvitationDetail = () => {
  const previewRes = localStorage.getItem("imagePreview");
  return (
    <Box bgImage={invitationBG}>
      <Box
        fontWeight={"semibold"}
        fontSize={36}
        fontFamily={"lato"}
        textAlign={{ base: "center", md: "left" }}
        pt={5}
        pl={5}
      >
        Share Invitation
      </Box>

      <Flex
        justifyContent={"space-evenly"}
        flexDir={{ base: "column", md: "row" }}
      >
        {/* Image Preview */}
        <Box
          p={"10"}
          margin={"auto"}
          w={{ base: "80%", md: "40%" }}
          bgImage={invitationBG}
          borderRadius={"10"}
        >
          <Image margin={"auto"} src={previewRes} />
        </Box>

        {/* Multi Step Form */}
        <Box
          borderRadius={"10px"}
          bg={"white"}
          h={"100%"}
          margin={"auto"}
          w={{ base: "80%", md: "40%" }}
        >
          <Multistep />
        </Box>
      </Flex>
    </Box>
  );
};

export default CreateInvitationDetail;
